<template>
	<div class="confirm-delete-page">
		<div class="page-center">
			<!-- Logo centrado -->
			<div class="text-center mb-5">
				<img :src="require('@/assets/Svg/logoH.svg')" alt="LAOT" class="logo-header" />
			</div>

			<!-- Tarjeta única central -->
			<v-card class="main-card" outlined>
				<!-- Header de la tarjeta -->
				<div class="card-header">
					<v-icon size="36" color="#F4516C" class="mb-2">mdi-alert-circle-outline</v-icon>
					<h1 class="title-main">Confirmar eliminación de cuenta</h1>
					<p class="subtitle-text">Revisa la información antes de confirmar</p>
				</div>

				<v-card-text class="px-6 pt-4 pb-5">
					<!-- Alertas -->
					<v-alert v-if="!token" type="error" dense border="left" colored-border class="mb-4">
						Enlace sin token válido. Revisa tu correo e intenta nuevamente.
					</v-alert>
					<v-alert v-if="errorMessage" type="error" dense border="left" colored-border class="mb-4">
						{{ errorMessage }}
					</v-alert>
					<v-alert v-if="successMessage" type="success" dense border="left" colored-border class="mb-4">
						{{ successMessage }}
					</v-alert>

					<!-- Grid de consecuencias 2x2 -->
					<div class="info-grid mb-4">
						<div class="info-item">
							<v-icon color="#2D4B95" class="mb-1" small>mdi-clock-outline</v-icon>
							<span class="info-label">14 días de gracia</span>
							<span class="info-desc">Podrás cancelar antes de que se ejecute</span>
						</div>
						<div class="info-item">
							<v-icon color="#F4516C" class="mb-1" small>mdi-shield-off-outline</v-icon>
							<span class="info-label">Datos anonimizados</span>
							<span class="info-desc">Nombre, correo, teléfono y foto se eliminan</span>
						</div>
						<div class="info-item">
							<v-icon color="#3EBFA3" class="mb-1" small>mdi-history</v-icon>
							<span class="info-label">Historial conservado</span>
							<span class="info-desc">Las interacciones quedan como "Usuario Eliminado"</span>
						</div>
						<div class="info-item">
							<v-icon color="#888" class="mb-1" small>mdi-lock-outline</v-icon>
							<span class="info-label">Acceso revocado</span>
							<span class="info-desc">No podrás acceder con esta cuenta</span>
						</div>
					</div>

					<!-- Nota legal compacta -->
					<div class="legal-note mb-5">
						<v-icon x-small color="#2D4B95" class="mr-1">mdi-information-outline</v-icon>
						<span>Conforme a la Ley 21.719. Derechos: <a href="mailto:mcereceda@laot.cl" class="link-text">mcereceda@laot.cl</a></span>
					</div>

					<!-- Botones -->
					<div class="d-flex gap-3">
						<v-btn
							outlined
							color="#2D4B95"
							class="flex-grow-1"
							:disabled="loading"
							@click="goToLogin"
						>
							Cancelar
						</v-btn>
						<v-btn
							color="#F4516C"
							dark
							class="flex-grow-1"
							:disabled="!token || loading || !!successMessage"
							:loading="loading"
							@click="confirmDeletion"
						>
							<v-icon left small>mdi-check</v-icon>
							Confirmar eliminación
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</div>
	</div>
</template>

<script>
import request from '@/helpers/request'

export default {
	name: 'ConfirmUserDelete',
	data() {
		return {
			token: null,
			loading: false,
			errorMessage: '',
			successMessage: '',
		}
	},
	mounted() {
		this.token = this.$route.query.token || this.$route.params.token || null
	},
	methods: {
		async confirmDeletion() {
			if (!this.token || this.loading) {
				return
			}

			this.loading = true
			this.errorMessage = ''
			this.successMessage = ''

			try {
				const response = await request.post('auth/confirmDeletion', {
					token: this.token,
				})

				const data = response && response.data ? response.data : response
				this.successMessage = (data && data.message)
					? data.message
					: 'Tu solicitud fue confirmada correctamente. Tu cuenta será anonimizada según el plazo informado.'
			} catch (error) {
				const responseMessage = error && error.response && error.response.data
					? error.response.data.message
					: null

				this.errorMessage = responseMessage || 'No fue posible confirmar la eliminación. El enlace puede estar vencido o ya usado.'
			} finally {
				this.loading = false
			}
		},
		goToLogin() {
			this.$router.push({ path: '/login' })
		},
	},
}
</script>

<style scoped>
.confirm-delete-page {
	min-height: 100vh;
	margin: auto;
	background: linear-gradient(135deg, #f0f4fc 0%, #e8eef8 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px 16px;
}

.page-center {
	width: 100%;
	max-width: 480px;
}

.logo-header {
	height: 36px;
	object-fit: contain;
}

.main-card {
	border-radius: 18px;
	border: 1px solid #dde6f5 !important;
	box-shadow: 0 8px 32px rgba(45, 75, 149, 0.10);
	overflow: hidden;
}

.card-header {
	background: linear-gradient(135deg, #2D4B95 0%, #3d5db5 100%);
	padding: 24px 24px 20px;
	text-align: center;
}

.title-main {
	font-size: 20px;
	font-weight: 700;
	color: white;
	letter-spacing: -0.3px;
	margin: 6px 0 4px;
}

.subtitle-text {
	font-size: 13px;
	color: rgba(255,255,255,0.75);
	margin: 0;
}

/* Grid 2x2 de consecuencias */
.info-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
}

.info-item {
	background: #f7f9fc;
	border: 1px solid #e8eef6;
	border-radius: 10px;
	padding: 12px 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 2px;
}

.info-label {
	font-size: 13px;
	font-weight: 700;
	color: #1a1a1a;
	line-height: 1.3;
}

.info-desc {
	font-size: 11.5px;
	color: #777;
	line-height: 1.4;
}

.legal-note {
	font-size: 12px;
	color: #888;
	display: flex;
	align-items: center;
}

.link-text {
	color: #2D4B95;
	text-decoration: none;
	font-weight: 600;
}

.link-text:hover {
	text-decoration: underline;
}

.gap-3 {
	gap: 10px !important;
}

@media (max-width: 400px) {
	.info-grid {
		grid-template-columns: 1fr;
	}
	.title-main {
		font-size: 17px;
	}
}

::v-deep .v-btn {
	text-transform: none !important;
	letter-spacing: 0 !important;
	border-radius: 10px !important;
}
</style>
